<template>
    <div id="app">
        <div v-if="home" class="header-outer-wrapper">
            <div class="text-xs-center header-wrap">
                <div @click="navPage('/')">
                    <v-btn small dark >Home</v-btn>
                </div>
                <div @click="navPage('/Info')">
                    <v-btn small dark >Info</v-btn>
                </div>
                <div  @click="navPage('/register')">
                    <v-btn small dark >Register</v-btn>
                </div>
                <div @click="navPage('/gallery')">
                    <v-btn small dark >Gallery</v-btn>
                </div>
            </div>
        </div>
        <v-content>
            <v-layout row wrap>
                <v-flex xs12 class="main">
                    <router-view/>
                </v-flex>
            </v-layout>
        </v-content>
        <v-content v-if="footer">
            <v-layout row wrap>
                <v-flex xs12 class="main">
                    <img src="sponsors.png">
                </v-flex>
            </v-layout>
        </v-content>
    </div>
</template>

<script>
    import router from './router';

    export default {
        name: 'app',
        
        methods: {
            navPage (page) {
                router.push({path: page});
            }
        },
        computed: {
            home () {
                return this.$store.getters.home
            },
            footer () {
                return this.$store.getters.footer
            }
        }
    }
</script>


<style>
    @import 'assets/css/main.css';

</style>

